namespace advisorop.components.advisor {

    class SelectCuCompanyGroupController {

        selectedCompanyGroup: domains.ICompanyGroup;
        isCompanyGroupSelected: boolean = false;
        onSelectedCompanyGroup: any;
        showLabel: boolean = true;
        
        static $inject = ["identityService", "servicerService"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {
        }


        searchCompanyGroup(searchTerm: string): ng.IPromise<{}> {

            return this.servicerService.searchCompanyGroupByName(searchTerm)
                .then((response) => {
                    return <Array<domains.CompanyGroup>>response.data;
                });
        }

        onSelectCompanyGroup(item, model, label, event): void {            
            this.isCompanyGroupSelected = true;
            this.onSelectedCompanyGroup({ companyGroup: item });
            this.selectedCompanyGroup = null;

        }

        clearSelectedCompanyGroup(): void {
            this.selectedCompanyGroup = null;
            this.isCompanyGroupSelected = false;
            this.onSelectedCompanyGroup({ companyGroup: null });
        }
        
        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }


    class SelectCuCompanyGroup implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                onSelectedCompanyGroup: '&',
                showLabel: "<"
            };
            this.controller = SelectCuCompanyGroupController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/select-cu-company-group.html';
        }
    }
    angular.module(Constants.APP).component("selectCuCompanyGroup", new SelectCuCompanyGroup());


}